<div class="table-view-list">
    <div class="top-row-container">
        <div class="edit-buttons">
            <div class="edit-buttons-sub">
                <app-button
                    [disabled]="buttonsBlocked"
                    [buttonType]="'secondary'"
                    [leftIcon]="'edit'"
                    [label]="'translations.button.editApp' | translate"
                    (clickEmitter)="openEditTranslationsDialog($event, 'app')"
                ></app-button>
                <app-button
                    [disabled]="buttonsBlocked"
                    [buttonType]="'secondary'"
                    [leftIcon]="'edit'"
                    [label]="'translations.button.editVar' | translate"
                    (clickEmitter)="openEditTranslationsDialog($event, 'variant')"
                ></app-button>
                <app-button
                    [disabled]="buttonsBlocked"
                    [buttonType]="'secondary'"
                    [leftIcon]="'edit'"
                    [label]="'translations.button.editInv' | translate"
                    (clickEmitter)="openEditTranslationsDialog($event, 'invariant')"
                ></app-button>
                <app-button
                    [disabled]="buttonsBlocked"
                    [buttonType]="'secondary'"
                    [leftIcon]="'edit'"
                    [label]="'translations.button.editAttr' | translate"
                    (clickEmitter)="openEditTranslationsDialog($event, 'attribute')"
                ></app-button>
            </div>
            <div class="edit-buttons-sub">
                @if (hasEditDefaultPermission$ | async) {
                    <app-button
                        [disabled]="buttonsBlocked"
                        [buttonType]="'secondary'"
                        [leftIcon]="'edit'"
                        [label]="'translations.button.editAppDefault' | translate"
                        (clickEmitter)="openEditTranslationsDialog($event, 'defaultApp')"
                    ></app-button>
                }
            </div>
        </div>

        @if (buttonsBlocked) {
            <mat-icon class="icon">autorenew</mat-icon>
        }
    </div>

    <div class="blueprint-section">
        <div class="blueprint-header">
            <h2>{{ 'translations.button.editVar' | translate }}</h2>
            <app-button
                [disabled]="buttonsBlocked || !unSubmittedChanges"
                [buttonType]="'secondary'"
                [leftIcon]="'edit'"
                [label]="(unSubmittedChanges ? 'translations.button.saveVariants' : 'translations.button.noVariantChanges') | translate"
                (clickEmitter)="saveVariantChangesFromTable()"
            ></app-button>
        </div>
        <table mat-table [dataSource]="variantTranslationsSrc" class="mat-elevation-z0">
            <ng-container matColumnDef="bpName">
                <th mat-header-cell *matHeaderCellDef>{{ 'blueprintList.column.group' | translate }}</th>
                <td mat-cell *matCellDef="let variantTranslations">{{ variantTranslations.bpName }}</td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let variantTranslations">
                    <div>
                        <table mat-table [dataSource]="variantTranslations.variants" class="mat-elevation-z1">
                            <ng-container matColumnDef="varName">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let variantTranslationItem">{{ variantTranslationItem.varName }}</td>
                            </ng-container>

                            <ng-container matColumnDef="expandedTranslations">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let variantTranslationItem">
                                    <div>
                                        <table mat-table [dataSource]="variantTranslationItem.translations" class="mat-elevation-z2">
                                            <ng-container matColumnDef="key">
                                                <td mat-cell *matCellDef="let ls">{{ ls.key }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="value">
                                                <td mat-cell *matCellDef="let ls">
                                                    <input [disabled]="buttonsBlocked" type="text" [(ngModel)]="ls.value"
                                                           (ngModelChange)="recalculateEqual()">
                                                </td>
                                            </ng-container>

                                            <tr mat-row *matRowDef="let row; columns: displayedColumns3;"></tr>
                                        </table>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                        </table>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>

